import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { EMarkAsReadNotificationActionTypes, TMarkAsReadNotificationSucceed } from './types';

export const markAsReadSucceed: (id: number) => TMarkAsReadNotificationSucceed = actionGenerator<
  EMarkAsReadNotificationActionTypes.Succeed,
  number
>(EMarkAsReadNotificationActionTypes.Succeed);
